import React from 'react'

const CardReminder = () => {
  return (
    <div className='card-event' style={{ backgroundColor: "white" }} >
            <div className='card-event-top' >
                <span className='tooltip-event' >Reminder</span>
            </div>
            <div className='card-event-bottom' >
                <div className='card-event-bottom-left' >
                    <span style={{ marginBottom: "7px" }} >Meeting with Raju</span>
                    <span>12 Jan 2023 [9 am - 11 am]</span>
                </div>
                <div className='card-event-bottom-images' >
                    <img src="https://www.georgetown.edu/wp-content/uploads/2022/02/Jkramerheadshot-scaled-e1645036825432-1050x1050-c-default.jpg" />
                    <img src='https://t3.ftcdn.net/jpg/02/43/12/34/360_F_243123463_zTooub557xEWABDLk0jJklDyLSGl2jrr.jpg' />
                    <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cGVyc29ufGVufDB8fDB8fHww" />
                </div>
            </div>
        </div>
  )
}

export default CardReminder